<template>
	<j-box class="flex bg4 bb1 bc7--l3 sticky mb6">
		<j-box class="flex wrap xs-12 md-pl10 md-pr10 pr4 pl4">
			<!-- Headline -->
			<j-headline class="xs-12 md-3 fs7 lh125 fw7 c1 pt3 pb3">
				{{ headline }}
				<small class="c6 fs4">{{ subheadline }}</small>
			</j-headline>

			<!-- Menu -->
			<j-box class="flex xs-12 md-9">
				<j-box-horizontal-scroll
					class="flex xs-12 xs-middle xs-left md-right md-mt0"
				>
					<router-link
						v-for="(item, i) in links"
						:key="i"
						:to="item.to"
						class="link ml0 mr8 md-mr0 md-ml8 pt4 pb4 pr2 pl2"
						exact-active-class="link--active"
					>
						{{ item.name }}
					</router-link>
				</j-box-horizontal-scroll>
			</j-box>
		</j-box>
	</j-box>
</template>

<script>
import "@/assets/css/tokens.css"
import JBox from "@/components/JBox/"
import JHeadline from "@/components/JHeadline/"
import JBoxHorizontalScroll from "@/components/JBoxHorizontalScroll/"

export default {
	name: "crm-submenu",
	components: { JBox, JHeadline, JBoxHorizontalScroll },
	props: {
		headline: {
			type: String,
			deafult: ""
		},
		subheadline: {
			type: String,
			deafult: ""
		},
		links: {
			type: Array,
			default: []
		}
	}
}
</script>

<style scoped>
.link {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	color: var(--color7-dark-1);
	font-weight: var(--fontWeight400);
	font-size: var(--fontSize3);
	line-height: var(--lineHeight125);
	font-weight: var(--fontWeight7);
	text-decoration: none;
	text-transform: uppercase;
	white-space: nowrap;
	border-top: 2px solid transparent;
	border-bottom: 2px solid transparent;
	transition: all 300ms ease-out;
	cursor: pointer;
}

.link:hover {
	color: var(--color1);
}

.link--active {
	color: var(--color1);
}

.link::before {
	content: "";
	position: absolute;
	bottom: 0;
	width: 100%;
	height: 3px;
	background-color: var(--color2);
	transform: translateY(10px);
	opacity: 0;
	transition: all 300ms ease-out;
}

.link--active.link::before {
	transform: translateY(2px);
	opacity: 1;
}

@media (--md) {
	.custom-max-width {
		max-width: var(--maxWidth3);
	}

	.sticky {
		position: sticky;
		top: 0;
		z-index: 99;
	}
}
</style>
